import api from './api';

const subcontractService = {
  getContractors:         (token)       => api.get('/subcontract/contractors', token),
  createContractor:       (data, token) => api.post('/subcontract/contractors', data, token),
  getContractorEmployees: (token)       => api.get('/subcontract/employees', token),
  createContractorEmployee:(data, token)=> api.post('/subcontract/employees', data, token),
};

export default subcontractService;
